import {
  configureNotificationShell,
  initNotificationListeners as initNotificationShellListeners,
  renderNotificationShade as renderNotificationShellShade,
  showToast as showNotificationShellToast,
  toggleShade as toggleNotificationShellShade,
} from "../../shared/ui/notifications.js";
import { getNotificationText } from "./notificationTextRenderer.js";
import {
  handleDismissAll,
  handleDismissClick,
  handleNotificationClick,
  isApprovalNotification,
  setNotificationShadeCloser,
} from "./notificationRuntime.js";

let isConfigured = false;

function ensureNotificationController() {
  if (isConfigured) {return;}

  configureNotificationShell({
    getNotificationText,
    handleNotificationClick,
    handleDismissClick,
    handleDismissAll,
    isApprovalNotification,
  });
  setNotificationShadeCloser(toggleNotificationShellShade);
  isConfigured = true;
}

/**
 * Sets up notification behavior and shell listeners.
 */
export function initNotificationListeners() {
  ensureNotificationController();
  initNotificationShellListeners();
}

/**
 * Opens, closes, or toggles the notification shade.
 * @param {boolean} [forceState] Optional explicit open state.
 */
export function toggleShade(forceState) {
  ensureNotificationController();
  toggleNotificationShellShade(forceState);
}

/**
 * Renders the current notification shade contents.
 */
export function renderNotificationShade() {
  ensureNotificationController();
  renderNotificationShellShade();
}

/**
 * Shows an app notification toast.
 * @param {object} notification Notification document data.
 */
export function showToast(notification) {
  ensureNotificationController();
  showNotificationShellToast(notification);
}
